module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh":{"all":"全部"},"en":{"all":"All"},"fr":{"all":"Tout"},"de":{"all":"Alle"},"jp":{"all":"すべて"},"es":{"all":"Todo"},"pt":{"all":"Todos"},"it":{"all":"tutto"},"tw":{"all":"全部"},"kr":{"all":"모두"}}')
  delete Component.options._Ctor
}
